import { call, cancel, select, throttle } from 'redux-saga/effects';

import * as D from '../../deps';

const logger = D.Logger.child({
  component: 'analytics/stats/sagas/audioPlayer',
});

const maxNumOfConsecutiveError = 5;
const defaultTimeoutThreshold = 3000;
let numOfConsecutiveError = 0;
let timeoutThreshold = defaultTimeoutThreshold;

let playheadWatcherTask;
let playheadUpdateTimeout;

function* resetPlayheadUpdateWatcher() {
  numOfConsecutiveError = 0;
  timeoutThreshold = defaultTimeoutThreshold;
  yield call(clearTimeout, playheadUpdateTimeout);
  yield cancel(playheadWatcherTask);
}

function* activatePlayheadUpdateWatcher(data, action) {
  if (action) {
    data.currentTime = action.payload.AUDIO_CURRENT_TIME;
  }

  const trackData = yield select(D.getInDomain('playback.utils.getTrackDataForLogging'));

  clearTimeout(playheadUpdateTimeout);
  playheadUpdateTimeout = setTimeout(() => {
    const logData = {
      ...data,
      ...trackData,
    };

    logger.warn(`Playhead hasn't been updated for ${timeoutThreshold} milliseconds`, logData);
    numOfConsecutiveError++;
    if (numOfConsecutiveError < maxNumOfConsecutiveError) {
      timeoutThreshold = timeoutThreshold * 2;
      activatePlayheadUpdateWatcher(logData);
    } else {
      resetPlayheadUpdateWatcher();
    }
  }, timeoutThreshold);
}

export function* togglePlayheadWatcher({ type, payload: { isPreload } }) {
  if (type === D.Constants.AudioPlayer.AudioPlayerActions.PLAYING) {
    if (playheadUpdateTimeout) {
      yield call(resetPlayheadUpdateWatcher);
    }
    const logData = {
      isPreload,
    };
    yield call(activatePlayheadUpdateWatcher, logData); // make the first call before UPDATE actually been called
    playheadWatcherTask = yield throttle(
      1000,
      D.Constants.AudioPlayer.AudioPlayerActions.UPDATE,
      activatePlayheadUpdateWatcher,
      logData,
    );
  } else if (playheadUpdateTimeout || playheadWatcherTask) {
    yield call(resetPlayheadUpdateWatcher);
  }
}
